import {
  AIContext,
  getTranslatedText,
  useActivityTracker,
  getButtonVariant
} from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import { Button, TextStyle } from '@superops/ui-design-system';
import React, { useContext, useState } from 'react';
import { useIntl } from 'react-intl';
import { AI_FEEDBACK_TYPES } from '../helpers';

const AICopyAndPaste = ({
  data,
  sendActivity,
  summaryData,
  buttonVariant,
  setShowRating,
  showRatingOnCopy
}) => {
  const intl = useIntl();

  const [copied, setCopied] = useState(false);

  const aiContext = useContext(AIContext);

  const onCopy = () => {
    setCopied(true);
    if (data?.onCopy) {
      data?.onCopy(summaryData, data);
    } else {
      sendActivity({ type: AI_FEEDBACK_TYPES.COPY_PASTE });
    }

    setTimeout(() => {
      setCopied(false);
    }, 2000);

    let mixpaneleventOnCopy;

    const getMixpanelEventOnCopy = aiContext?.aiData?.getMixpanelEventOnCopy;

    if (getMixpanelEventOnCopy) {
      mixpaneleventOnCopy = getMixpanelEventOnCopy(data);
    } else if (aiContext?.aiData?.mixpanelEventOnCopy) {
      mixpaneleventOnCopy = aiContext?.aiData?.mixpanelEventOnCopy;
    }

    if (mixpaneleventOnCopy) {
      useActivityTracker(mixpaneleventOnCopy);
    }

    if (showRatingOnCopy) {
      setShowRating(true);
    }
  };

  const buttonText =
    data?.copyButtonText ||
    getTranslatedText(intl, 'ticket.aiFloater.copyAndPaste');
  const icon = data?.copyIcon || 'InsertText';
  const copySuccessText =
    data?.copySuccessText ||
    getTranslatedText(intl, 'admin.customerSupportAccess.copied');

  const buttonVariantData = getButtonVariant({
    variant: buttonVariant,
    defaultVariant: 'aiSecondary'
  });

  return (
    <div>
      {copied ? (
        <>
          <div className="flex g10 actr h-28">
            <div className="flex ignoreOverride">
              <SVGIcon name="LoadingSuccessAnimated" size="sm" />
            </div>
            <div className="text-white flex">
              <TextStyle>{copySuccessText}</TextStyle>
            </div>
          </div>
        </>
      ) : (
        <Button
          onClick={onCopy}
          icon={
            <span className="ignoreOverride">
              <SVGIcon name={icon} color="#ffffffcc" size="sm" />
            </span>
          }
          size="slim"
          {...buttonVariantData}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export default AICopyAndPaste;
